export const LOGIN    = 'LOGIN'
export const LOGOUT   = 'LOGOUT'
export const SET_USER = 'SET_USER'
export const SET_USER_TYPE = 'SET_USER_TYPE'
export const SET_ACCESS="SET_ACCESS"
export const CLIENT_FILTER = 'CLIENT_FILTER'
export const SITE_FILTER = 'SITE_FILTER'
export const SET_CLIENT_OPTIONS = 'SET_CLIENT_OPTIONS'
export const SET_SITE_OPTIONS = 'SET_SITE_OPTIONS'